import createIcon from '../../createIcon';

/**
 * @component @name FrontHand
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOEMxOC4zMSA4IDE3Ljc1IDguNTYgMTcuNzUgOS4yNVYxNUgxNy4yNUMxNS42IDE1IDE0LjI1IDE2LjM1IDE0LjI1IDE4SDEzLjI1QzEzLjI1IDE1Ljk2IDE0Ljc4IDE0LjI4IDE2Ljc1IDE0LjAzVjMuMjVDMTYuNzUgMi41NiAxNi4xOSAyIDE1LjUgMkMxNC44MSAyIDE0LjI1IDIuNTYgMTQuMjUgMy4yNVYxMUgxMy4yNVYxLjI1QzEzLjI1IDAuNTYgMTIuNjkgMCAxMiAwQzExLjMxIDAgMTAuNzUgMC41NiAxMC43NSAxLjI1VjExSDkuNzVWMi43NUM5Ljc1IDIuMDYgOS4xOSAxLjUgOC41IDEuNUM3LjgxIDEuNSA3LjI1IDIuMDYgNy4yNSAyLjc1VjEySDYuMjVWNS43NUM2LjI1IDUuMDYgNS42OSA0LjUgNSA0LjVDNC4zMSA0LjUgMy43NSA1LjA2IDMuNzUgNS43NVYxNS43NUMzLjc1IDIwLjMxIDcuNDQgMjQgMTIgMjRDMTYuNTYgMjQgMjAuMjUgMjAuMzEgMjAuMjUgMTUuNzVWOS4yNUMyMC4yNSA4LjU2IDE5LjY5IDggMTkgOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FrontHand = createIcon('FrontHand', [
  [
    'path',
    {
      d: 'M19 8C18.31 8 17.75 8.56 17.75 9.25V15H17.25C15.6 15 14.25 16.35 14.25 18H13.25C13.25 15.96 14.78 14.28 16.75 14.03V3.25C16.75 2.56 16.19 2 15.5 2C14.81 2 14.25 2.56 14.25 3.25V11H13.25V1.25C13.25 0.56 12.69 0 12 0C11.31 0 10.75 0.56 10.75 1.25V11H9.75V2.75C9.75 2.06 9.19 1.5 8.5 1.5C7.81 1.5 7.25 2.06 7.25 2.75V12H6.25V5.75C6.25 5.06 5.69 4.5 5 4.5C4.31 4.5 3.75 5.06 3.75 5.75V15.75C3.75 20.31 7.44 24 12 24C16.56 24 20.25 20.31 20.25 15.75V9.25C20.25 8.56 19.69 8 19 8Z',
      key: 'tnuunc',
    },
  ],
]);

export default FrontHand;
